import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="glass-panel rounded-lg p-12 max-w-md w-full text-center">
        <XCircle className="w-10 h-10 mx-auto text-white/50 mb-6" />
        <h1 className="font-display font-medium text-2xl tracking-tight mb-2">Checkout cancelled</h1>
        <p className="text-sm text-white/50 font-light mb-8">
          No charge was made. Your cart is saved — come back whenever you're ready.
        </p>
        <Link
          data-testid="back-to-shop-link"
          to="/"
          className="inline-block bg-white text-black rounded-full px-8 py-3.5 text-xs uppercase tracking-[0.22em] font-semibold transition-transform duration-300 hover:scale-105"
        >
          Return to the Drop
        </Link>
      </div>
    </main>
  );
}
